<template>
  <div
    class="hover-card"
  >
    <div class="hover-card-content">
      <h3>{{ item.title }}</h3>

      <div class="product-description">
        {{ item.abstract }}
      </div>
      <div class="learn-more">
        <router-link
          :to="item.path"
          tag="a"
          class="product-link"
        >
          Learn More
        </router-link>
      </div>
    </div>
    <div class="hover-card-action-group">
      <HighlightButton
        :disabled="outOfStock"
        :class="stockManagedClass"
        :title="stockManagedText"
        button-type="pill"
        button-style="solid"
        button-size="small"
        @clicked="addToCartLinkClicked"
      />
    </div>
  </div>
</template>

<script>
import carouselProductMixin from '../../mixins/carouselProductMixin'
import purchaseMixin from '@aspedia/vuejs-ecommerce-ui/mixins/item-purchase-qty.js'
import generalutils from '@aspedia/vuejs-ecommerce-ui/mixins/general-utils.js'

export default {
  name: 'hover-card',
  mixins: [carouselProductMixin, purchaseMixin, generalutils]
}
</script>

<style lang="scss">
@import '~@scss/custom.scss';

.hover-card {
    display: none;
    transition: opacity .15s ease-in-out;
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--product-hover-state-background);
    z-index: 4;
    padding: var(--product-hover-content-padding);
    color: var(--product-hover-state-text-color);
    opacity: 0;
    flex-direction: column;

    @include media-breakpoint-up(md) { display:flex; }

    .product-link {
      color: var(--product-hover-state-text-color);
    }
}

.product-description {
  font-size:.867em;
  margin-bottom:1em;
}

.hover-card-action-group {
    display: flex;
    align-items: flex-end;
    justify-items: flex-end;
    flex-grow: 1;
    justify-content: space-around;
}
</style>
